import { styled } from "@mui/material/styles";

// Components
import { IconButton } from "@mui/material";

// Themes
import theme from "../Theme";

const styledName = "IconButton";

export const StyledIconButton = styled(IconButton, { name: styledName })({
  "&": {
    height: "40px",
    width: "40px",

    fill: theme.palette.grey[700],
    fontSize: "2.4rem",

    ":hover": {
      cursor: "pointer",
      fill: theme.palette.primary.main,
    },
    ":active": {
      animation: `shaking 0.2s linear infinite`,
    },
  },
});
